import axios from "axios";
import { SOLUTIONS_URL } from "../../API/Api";

const GetAllSolutions = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    const response = await axios({
        method: "GET",
        baseURL: `${SOLUTIONS_URL}`,
        headers,
        params: { ...data },
    });
    return response.data;
};

const SearchOnSolutions = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    const response = await axios({
        method: "GET",
        baseURL: `${SOLUTIONS_URL}/user-solutions`,
        headers,
        params: { ...data },
    });

    return response.data;
};

const GetSingleSolutions = async (id, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    console.log(id)
    const response = await axios({
        method: "GET",
        baseURL: `${SOLUTIONS_URL}/${id}`,
        headers,
    });

    return response.data;
};

const SolutionSevices = {
    GetAllSolutions,
    SearchOnSolutions,
    GetSingleSolutions,
};

export default SolutionSevices;
